import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/user/report/organization/summary")({
  component: lazyRouteComponent(async () => await import("../../../../../views/OrgReport")),
  staticData: { application: "Reports" },
});
